import { cn } from '@/lib/utils';

interface SkeletonProps {
  className?: string;
  variant?: 'text' | 'circular' | 'rectangular';
  animation?: 'pulse' | 'none';
}

/**
 * Reusable Skeleton component for loading states
 *
 * @example
 * // Simple text line
 * <Skeleton className="h-4 w-[250px]" />
 *
 * @example
 * // Avatar circle
 * <Skeleton variant="circular" className="h-12 w-12" />
 *
 * @example
 * // Card placeholder
 * <Skeleton variant="rectangular" className="h-32 w-full" />
 */
export function Skeleton({
  className,
  variant = 'rectangular',
  animation = 'pulse',
}: SkeletonProps) {
  const baseStyles = 'bg-slate-200 dark:bg-slate-700';

  const variantStyles = {
    text: 'rounded',
    circular: 'rounded-full',
    rectangular: 'rounded-md',
  };

  const animationStyles = {
    pulse: 'animate-pulse',
    none: '',
  };

  return (
    <div
      className={cn(
        baseStyles,
        variantStyles[variant],
        animationStyles[animation],
        className
      )}
      aria-live="polite"
      aria-busy="true"
    />
  );
}
